import { getCookieOptions } from '~~/common/js/universal/utils';
import { sendEvent } from '~~/common/js/client/analytics';
import { SEARCHES_AFTER_INSTALL as ECSAI_COOKIE } from '~~/common/js/constants/cookies';

export default {
  mounted() {
    if (!this.$cookies || !this.$route || !this.$route.query) {
      return;
    }

    const cookieValue = parseInt(this.$cookies.get(ECSAI_COOKIE) || 0, 10);
    // ECSAI stands for Ecosia Search after install

    if (cookieValue === 1) {
      // The url param 'method' is appended by the Ecosia extension
      // when a search is triggered from the url topbar.
      // It is not appended when a search is triggered from the new tab.
      // If the addon parameter is missing the search was triggered from another source
      // e.g indexpage
      const { addon, addonversion } = this.$route.query;
      const position = addon ? this.$route.query.method || 'new_tab' : 'undefined';

      const context = {
        addon,
        addonversion,
        position
      };

      sendEvent('first_search_after_install', context);
    }

    // if the cookie is available we want to increase the value
    if (cookieValue >= 1) {
      this.$cookies.set(ECSAI_COOKIE, cookieValue + 1, getCookieOptions());
    }
  },
};
